import { Component, ElementRef, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { API_URL } from 'src/shared/common';
import { IcdService } from 'src/shared/services/icd.service';
import { SearchGlobalService } from 'src/shared/services/search-global.service';
import { FormControl } from '@angular/forms';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTree, MatTreeNestedDataSource } from '@angular/material/tree';
import { MatTabChangeEvent } from '@angular/material/tabs';

// bootstrap
declare var bootstrap: any;

interface searchItem {
    app: string;
    app_name: string;
    code: string;
    content: string;
    href: string;
    id: string;
    model: string;
    name: string;
    name_vn: string;
    split_href: Array<string>;
    color: string;
}

interface SearchTreeItem {
    model: string;
    id: string;
    app?: string;
    name: string;
    name_vn: string;
    code: string;
    childs: SearchTreeItem[];
    content?: string;
    href?: string;
    scores: number;
}

interface SearchTreeResult {
    ICD9: SearchTreeItem[];
    ICD10: SearchTreeItem[];
}

@Component({
    selector: 'app-search-global-detail',
    templateUrl: './search-global-detail.component.html',
    styleUrls: ['./search-global-detail.component.scss'],
})
export class SearchGlobalDetailComponent implements OnInit {
    searchQuery: string = '';
    searchRecommend: any;
    selectedIndex: number = -1;
    appList: any;
    searchResult: searchItem[];
    searchTreeResult: SearchTreeItem[];
    responseTime: any;
    dataHtml: any;
    appFilter = new FormControl('ICD-10', {nonNullable: true});
    offcanvas: any;
    displayMode = new FormControl('flat', {nonNullable: true})


    previousSearchQuery: string = '';
    like: boolean | null = null;
    @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;
    @ViewChild('recommendBox') recommendBox: ElementRef;
    @ViewChild('boxSearch') boxSearch: ElementRef;
    @ViewChild('del') del: ElementRef;
    @ViewChildren('tree') tree: QueryList<MatTree<SearchTreeItem, SearchTreeItem>>;

    treeControl = new NestedTreeControl<SearchTreeItem>(node => node.childs)
    // dataSource = new MatTreeNestedDataSource<SearchTreeItem>()
    hasChild = (_: number, node: SearchTreeItem) => !!node.childs && node.childs.length > 0;
    baseUrl: string;
    searchTimer: any;
    isAllButtonActive = false;
    isIcd10ButtonActive = false;
    isIcd9ButtonActive = false;
    isLoading: boolean = false;
    isLoadingSearch: boolean = false;
    idHis: number;
    eve: number[] = [];
    constructor(
        private searchService: SearchGlobalService,
        private router: Router,
        private route: ActivatedRoute,
        private icdService: IcdService,
        
        private sanitizer: DomSanitizer,
        private renderer: Renderer2,
        private toastService: ToastrService
    ) {
        // const protocol = window.location.protocol; // 'https:'
        // const hostname = window.location.hostname; // 'chat.openai.com'
        // const port = window.location.port ? `:${window.location.port}` : ""; // ':port' or '' if no port

        this.baseUrl = `${API_URL}`;
    }
    getSafeHtml() {
        return this.sanitizer.bypassSecurityTrustHtml(this.dataHtml);
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe((params) => {
            this.searchQuery = params['q'] || '';
            if (params['app']) {
                this.appFilter.setValue(params['app']);
            }
            if (params['display']) {
                console.log(params['display']);
                this.displayMode.setValue(params['display']);
            }
            this.getSearch();

            // this.searchService.rec(this.searchQuery).subscribe((results: any) => {
            //     this.searchRecommend = results.result;
            //     this.selectedIndex = -1;
            // });
        });
        this.renderer.listen('document', 'click', (event: MouseEvent) => {
            const clickedElement = event.target as Node;

            if (!this.recommendBox.nativeElement.contains(clickedElement)) {
                this.closeRec();
            }
            if (
                this.searchInput &&
                this.searchInput.nativeElement &&
                this.searchInput.nativeElement.contains(clickedElement)
            ) {
                if (this.searchRecommend) {
                    if (this.searchRecommend.length > 0) {
                        this.openRec();
                    }
                }
            }
        });
        this.displayMode.valueChanges.subscribe((value) => {
            this.loadData();
        })
        this.appFilter.valueChanges.subscribe((value) => {
            this.loadData();
        })
    }
    
    loadData() {
        const startTime = new Date();
        this.isLoading = true;
        this.searchService.search(this.searchQuery, this.appFilter.value, this.displayMode.value).subscribe((results: any) => {
            const endTime = new Date();
            this.responseTime = (endTime.getTime() - startTime.getTime()) / 1000;
            this.idHis = results.id;
            if (this.displayMode.value == 'flat') {
                this.searchResult = results.result.map((item: searchItem) => {
                    return {
                        ...item,
                        split_href: item.href.split('/'),
                    };
                });
            } else {
                if (this.appFilter.value === 'ICD-9') {
                    this.searchTreeResult = results.result.ICD9;
                } else {
                    this.searchTreeResult = results.result.ICD10;
                }
            }
            // this.searchService.getEvaluate(this.idHis).subscribe((results: any) => {
            //     if (this.eve.length === 0) {
            //         this.eve = results.evaluates;
            //     }
            // });
            this.isLoading = false;
        });
    }

    ngAfterViewInit() {
        this.tree.changes.subscribe(() => {
            for (let tree of this.tree) {
                let data: SearchTreeItem[] = tree.dataSource as SearchTreeItem[];
                tree.treeControl.dataNodes = data.slice();
                tree.treeControl.expandAll();
            }
        })
    }

    setActiveButton(filter: string) {
        this.appFilter.setValue(filter);
        this.router.navigate(['/search/query-global'], {
            queryParams: { q: this.searchQuery, app: this.appFilter.value },
        });
    }

    closeRec() {
        if (
            this.boxSearch &&
            this.boxSearch.nativeElement &&
            this.recommendBox &&
            this.recommendBox.nativeElement
        ) {
            this.boxSearch.nativeElement.classList.remove('bar-data');
            this.boxSearch.nativeElement.classList.add('bar');
            this.recommendBox.nativeElement.classList.add('hidden');
        }
    }
    openRec() {
        if (
            this.boxSearch &&
            this.boxSearch.nativeElement &&
            this.recommendBox &&
            this.recommendBox.nativeElement
        ) {
            this.boxSearch.nativeElement.classList.add('bar-data');
            this.boxSearch.nativeElement.style.margin= '0 auto';
            this.boxSearch.nativeElement.classList.remove('bar');
            this.recommendBox.nativeElement.classList.remove('hidden');
        }
    }
    onSearch() {
        this.isLoadingSearch = true;
        // Thực hiện tìm kiếm hoặc xử lý tìm kiếm tại đây
        this.previousSearchQuery = this.searchQuery;
        this.searchService.rec(this.searchQuery).subscribe(
            (results: any) => {
                this.isLoadingSearch = false;
                this.searchRecommend = results.result;
                this.selectedIndex = -1;
                if (this.searchRecommend.length > 0) {
                    this.openRec();
                } else {
                    this.closeRec();
                }
            },
            (error: any) => {
                this.isLoadingSearch = false;
            }
        );
    }
    onLike(index: number) {
        this.searchService.evaluate(this.idHis, index, 1).subscribe((results: any) => {
            this.eve[results.index] = results.like;
            if (results.status === 'success')
                this.toastService.success(`${results?.message}`, 'Thành công');
            else this.toastService.error(`${results?.message}`, 'Thất bại');
        });

        // this.searchService.getEvaluate(this.idHis).subscribe((results: any) => {
        //     this.eve = results.evaluates;
        // });
    }
    onUnLike(index: number) {
        this.searchService.evaluate(this.idHis, index, 0).subscribe((results: any) => {
            this.eve[results.index] = results.like;
            if (results.status === 'success')
                this.toastService.success(`${results?.message}`, 'Thành công');
            else this.toastService.error(`${results?.message}`, 'Thất bại');
        });

        // this.searchService.getEvaluate(this.idHis).subscribe((results: any) => {
        //     this.eve = results.evaluates;
        // });
    }
    handleInputChange() {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
            if (this.searchQuery.trim() !== this.previousSearchQuery) this.onSearch();
        }, 250);
    }

    handleKeyDown(event: KeyboardEvent) {
        if (event.key === 'ArrowDown' && this.selectedIndex < this.searchRecommend.length - 1) {
            event.preventDefault();
            this.selectedIndex++;
        } else if (event.key === 'ArrowUp' && this.selectedIndex > 0) {
            event.preventDefault();
            this.selectedIndex--;
        }
        if (this.selectedIndex >= 0 && this.searchRecommend[this.selectedIndex]) {
            this.searchQuery = this.searchRecommend[this.selectedIndex];
        }
        if (event.key === 'Enter') {
            event.preventDefault();
            if (this.searchQuery.length)
                this.getSearch();
        }
    }
    handleDelInput() {
        this.searchQuery = '';
        this.searchRecommend = [];
        this.closeRec();
    }
    onSearchItemClick(searchTerm: string) {
        // this.router.navigate(['/search/query-global'], {
        //     queryParams: { q: searchTerm, app: app, display: this.displayMode.value },
        // });
        this.previousSearchQuery = this.searchQuery;
        this.searchQuery = searchTerm;
        this.loadData()
        this.closeRec();
        // Adjust according to your routing setup
    }
    getSearch() {
        const startTime = new Date();
        this.isLoading = true;
        this.closeRec();
        this.searchService.search(this.searchQuery, this.appFilter.value, this.displayMode.value).subscribe(
            (results: any) => {
                const endTime = new Date();
                this.responseTime = (endTime.getTime() - startTime.getTime()) / 1000;
                this.idHis = results.id;

                if (this.displayMode.value == 'flat') {
                    this.searchResult = results.result.map((item: searchItem) => {
                        return {
                            ...item,
                            split_href: item.href.split('/'),
                        };
                    });
                } else {
                    if (this.appFilter.value === 'ICD-9') {
                        this.searchTreeResult = results.result.ICD9;
                    } else {
                        this.searchTreeResult = results.result.ICD10;
                    }
                }
                // this.searchService.getEvaluate(this.idHis).subscribe((results: any) => {
                //     this.eve = results.evaluates;
                // });
                this.isLoading = false;
            },
            (error) => {
                this.isLoading = false;
                this.toastService.error(`${error?.error.error}`, 'Thất bại');

            }
        );
    }
    getData(item: searchItem | SearchTreeItem) {

        this.offcanvas = new bootstrap.Offcanvas(document.getElementById('offcanvasRight')); 

        let id = item.id;
        let model = item.model.toLocaleLowerCase();
        let app = this.appFilter.value.replace('-', '')

        // let language = this.language
        // this.url = this.router.url.includes('icd10-dual')
        // if (this.url)
        //   language = 'dual'
        // this.isLoading = true;

        if (app === 'ICD10') {
            this.icdService.getDetailModel(model, id, 'vi').subscribe(
                (res) => {
                    // On successful response
                    // this.isLoading = false;
                    this.dataHtml = res.data.data.html;
                    this.offcanvas.show();
                },
                (error) => {
                    // On error
                    // this.isLoading = false;

                    console.error('An error occurred in getDetailModel:', error);
                    this.toastService.error(`${error?.error.error}`, 'Thất bại');
                }
            );
        } else if (app === 'ICD9') {
            this.icdService.getDetailModel_ICD9(model, id, 'vi').subscribe(
                (res) => {
                    // On successful response
                    // this.isLoading = false;
                    this.dataHtml = res.data.data.html;
                    this.offcanvas.show();
                },
                (error) => {
                    // On error
                    // this.isLoading = false;

                    console.error('An error occurred in getDetailModel_ICD9:', error);
                    this.toastService.error(`${error?.error.error}`, 'Thất bại');
                }
            );
        }
        
    }

}
